/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
import IntlMessageFormat from './core';
export * from './formatters';
export * from './core';
export * from './error';
export default IntlMessageFormat;
//# sourceMappingURL=index.js.map